module.exports = __webpack_public_path__ + "img/qxyl.e892f37d.png";